import { COMPANY_STATUS } from '../constants';
/**
*	NAME: convertShipperStatus
*	DESCRIPTION: convert shipper status to object to display
*	ARGUMENT: number
*	RETURN: object
*/
function convertCompanyStatus(companyStatusNum){

	var ret = {};

	if(companyStatusNum === COMPANY_STATUS.waitingApprove.code){
		ret = COMPANY_STATUS.waitingApprove.name;
	}
	else if(companyStatusNum === COMPANY_STATUS.approved.code){
		ret = COMPANY_STATUS.approved.name;
	}
	else if(companyStatusNum === COMPANY_STATUS.banned.code){
		ret = COMPANY_STATUS.banned.name;
	}
	

    return ret;
}

function companyStatusCellRenderer(params){

	var fontColor = '#000000';
	var bgColor = '#ffffff';
	var valueShow = '?';

	//## [DEBUG]
	// console.log('companyStatusCellRenderer');
	// console.log(params);

	if(params.value === COMPANY_STATUS.waitingApprove.code){
		fontColor = COMPANY_STATUS.waitingApprove.fontColor;
		bgColor = COMPANY_STATUS.waitingApprove.bgColor;
		valueShow = COMPANY_STATUS.waitingApprove.name;
	}
	else if(params.value === COMPANY_STATUS.approved.code){
		fontColor = COMPANY_STATUS.approved.fontColor;
		bgColor = COMPANY_STATUS.approved.bgColor;
		valueShow = COMPANY_STATUS.approved.name;
	}
	else if(params.value === COMPANY_STATUS.banned.code){
		fontColor = COMPANY_STATUS.banned.fontColor;
		bgColor = COMPANY_STATUS.banned.bgColor;
		valueShow = COMPANY_STATUS.banned.name;
	}


	var ret = "<div style='width: 100%; height: 100%; text-align: center; "
	ret += "background-color:" + bgColor + "; "
	ret += "color: " + fontColor + ";' >";
	ret += valueShow + "</div>"


	return ret;

}

export { 
	convertCompanyStatus,
	companyStatusCellRenderer, 
};


